<template>
  <tr
    :key="item.id"
    class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50 hover:tw-bg-primary-50/60 tw-duration-100"
  >
    <td class="tw-px-5 tw-py-3 tw-text-sm">{{ item.id }}</td>
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <button @click="copy(item.sku)" title="Copy SKU" 
      :class="[isLow ? '!tw-border-rose-100 !tw-text-rose-500 tw-bg-red-50 hover:tw-bg-red-100' : '']"
      class="tw-p-1 tw-bg-gray-50 tw-border tw-border-solid tw-border-transparent hover:tw-border-gray-200 tw-duration-200 hover:tw-bg-gray-100 tw-rounded tw-text-xs tw-w-fit tw-px-2 tw-flex tw-items-center tw-gap-2 tw-text-gray-500">
        <span>{{ item.sku }}</span>
      </button>
    </td>
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <div class="tw-flex tw-items-center tw-gap-2">
        <div v-if="isLow" class="tw-flex tw-animate-pulse tw-items-center tw-gap-1 tw-pe-2 tw-rounded tw-bg-rose-50 tw-px-1 tw-text-xs tw-py-0.5 tw-text-rose-600">
          <icon icon="si:alert-line" class="tw-text-rose-600 tw-text-lg" />
          <span class="tw-font-medium">{{ $t('common.low') }}</span>
        </div>
        <div class="tw-flex tw-items-center tw-gap-2">
          <div v-if="item.image_url" class="tw-w-14 tw-h-14 tw-rounded-md tw-overflow-hidden tw-border tw-border-solid tw-border-gray-200">
            <img :src="item.image_url" alt="" class="tw-w-full tw-h-full tw-object-cover">
          </div>
          <p class="tw-max-w-[500px]x tw-truncatex tw-whitespace-nowrap">{{ item.name }}</p>
        </div>
      </div>
    </td>
    <td class="tw-px-5 tw-py-3 tw-text-sm tw-text-center">
      <div class="tw-flex tw-gap-1 tw-items-center tw-justify-center">
        <p dir="ltr" class="tw-font-semibold tw-text-gray-600">
          <span>$</span>
          <span>{{ item.buying_price }}</span>
        </p>
        <icon icon="fluent:arrow-sort-20-filled" class="tw-text-gray-400 -tw-scale-x-100" />
        <p dir="ltr" class="tw-font-semibold tw-text-teal-600">
          <span>$</span>
          <span>{{ item.selling_price }}</span>
        </p>
      </div>
    </td>
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <div class="tw-flex tw-items-center tw-justify-center">
        <div class="tw-flex tw-items-center tw-gap-2 tw-px-2 tw-py-0.5 tw-bg-gray-100 tw-rounded tw-w-fit">
          <icon icon="solar:box-linear" class="tw-text-lg tw-text-gray-800" />
          <span class="tw-text-sm tw-font-semibold tw-text-black">{{ formatNumber(item.order_count, {}) }}</span>
        </div>
      </div>
    </td>
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <div class="tw-flex tw-items-center tw-gap-2 tw-w-full tw-justify-center">
        <icon v-if="false" icon="solar:box-linear" class="tw-text-lg tw-text-gray-800" />
        <span class="tw-text-sm tw-font-semibold" :class="[item.confirmation_rate <= 50 ? 'tw-text-amber-500' : 'tw-text-emerald-600']">{{ item.confirmation_rate }}%</span>
      </div>
    </td>
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <div class="tw-flex tw-items-center tw-gap-2 tw-w-full tw-justify-center">
        <icon v-if="false" icon="solar:box-linear" class="tw-text-lg tw-text-gray-800" />
        <span class="tw-text-sm tw-font-semibold" :class="[formatNumber(item.delivery_rate, {}) <= 40 ? 'tw-text-amber-500' : 'tw-text-blue-600']">{{ item.delivery_rate }}%</span>
      </div>
    </td>
    <td v-if="false" class="tw-px-5 tw-py-3 tw-text-sm tw-text-center">
      <p class="tw-font-semibold">{{ item.quantity }}</p>
    </td>
    <td class="tw-px-5 tw-py-3 tw-text-sm tw-text-center">
      <p class="tw-text-emerald-600 tw-font-semibold">{{ formatNumber(item.delivered_quantity, {}) }}</p>
    </td>
    <td class="tw-px-5 tw-py-3 tw-text-sm tw-text-center">
      <p class="tw-text-violet-600 tw-font-semibold">{{ formatNumber(item.shipped_quantity, {}) }}</p>
    </td>
    <td class="tw-px-5 tw-py-3 tw-text-sm tw-text-center">
      <p :class="[isLow ? 'tw-text-rose-600 !tw-bg-rose-50 tw-border-rose-300' : 'tw-text-gray-800']" class="tw-font-semibold tw-px-1 tw-py-0.5 tw-border tw-border-solid tw-bg-white tw-border-gray-300 tw-rounded">{{ formatNumber(item.available_quantity, {}) }}</p>
    </td>
    <td class="tw-px-5x tw-pr-0 tw-py-">
        <ProductTableActions />
    </td>
  </tr>
</template>

<script setup>
import { defineProps, toRef, provide, computed } from 'vue';
import ProductTableActions from './ProductTableActions';
import useAlert from '@/composables/useAlert';
import { useI18n } from 'vue-i18n';

const props = defineProps(['item']);
const item = toRef(props, 'item');
const isLow = computed(() => item.value.available_quantity <= item.value.stock_alert);
const i18n = useI18n()

const copy = (value) => {
  navigator.clipboard.writeText(value);
  useAlert(i18n.t('messages.copied-to-clipboard'))
}

const formatNumber = (number, type = {style: 'currency', currency: 'USD'}) => {
    return new Intl.NumberFormat('en', { maximumFractionDigits: 2, ...type }).format(number);
}

provide('product', item)

</script>

<style></style>
